import { type RouteRecordRaw } from "vue-router"

import { requiredAnalysisRoles } from "@/utils/analysis"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/analysemodelle",
    name: "AnalysisModelsPage",
    component: () => import("@/views/home/analyse-models/AnalyseModelsPage.vue"),
    meta: {
      requiresInstitutionContext: true,
      requiredRoles: requiredAnalysisRoles,
    },
  },
  {
    path: "/analyse/",
    name: "AnalysisPage",
    component: () => import("./analysis/AnalysisBasePage.vue"),
    meta: {
      requiresInstitutionContext: true,
      requiredRoles: requiredAnalysisRoles,
    },
    children: [
      {
        path: "",
        name: "FundingRelevantAnalysis",
        component: () => import("./analysis/FundingRelevantAnalysis.vue"),
      },
      {
        path: "faktor",
        name: "FactorIncreaseAnalysis",
        component: () => import("./analysis/FactorIncreaseAnalysis.vue"),
      },
      {
        path: "bezirksfoerderung",
        name: "DistrictFundingAnalysis",
        component: () => import("./analysis/DistrictFundingAnalysis.vue"),
      },
      {
        path: "belegungsanalyse",
        name: "OccupancyAnalysis",
        component: () => import("./analysis/OccupancyAnalysis.vue"),
      },
    ],
  },
]

export default routes
